import { useCallback } from 'react';
import { getCompanyMappings } from '../../../services/queries/MaggieCompanyQueries';
import { useAsync } from '../../../util/hook-utils';
import { useLoadingBarState } from '../../../components/LoadingBar/LoadingBarContext';
import { LoadingId } from '../../../types';
import { companyMappingResponseToVM } from '../../../schemas/CompanyMappings.schema';

export function useCompanyMappingsData(invalidateKey?: string) {
  const {
    actions: { startLoading, stopLoading },
  } = useLoadingBarState();

  const { data, error } = useAsync(
    useCallback(async () => {
      startLoading(LoadingId.getCompanyMappings);
      const mappings = await getCompanyMappings();
      stopLoading(LoadingId.getCompanyMappings);
      return mappings.map(companyMappingResponseToVM);
    }, [startLoading, stopLoading]),
    {
      id: invalidateKey ?? 'company-mappings-data',
    }
  );

  return { data, error };
}
